import { mediaBreakpoint } from '@commblades/commblades';
import styled from 'styled-components';

export const AmountContainer = styled.div`
&&& {
    display: flex;
    align-items: center;
    margin-bottom:1rem;
}`;

export const AmountWrapper = styled.span`
&&& {
    min-width: 160px;
    font-size: 2rem;
    font-weight: 800;
    margin-right: 2rem;
}`;

export const SliderWrapper = styled.div`
&&& {
    width: 50%;
    ${mediaBreakpoint.down('md')} {
        width: 100%;
      }
    margin-bottom: 1rem;
}`;

export const DescriptionWrapper = styled.div`
&&& {
    margin-bottom: 1rem;
}`;
